import Player from '@vimeo/player/dist/player.es'

export class Video {
    constructor(dataAttr) {
        window.videoDebugOn = false
        this.selector = dataAttr
        this.supposedCurrentTime = 0;
        this.canSeek = false;
        this.player;
        this.initialize()
    }

    initialize = () => {
        this.debug('Initializing', this.selector)
        jQuery("#popup-btn").attr("disabled", '')
        this.registerEventEnded(this.disableVimeoSeek(this.getVimeoPlayer(this.selector)))
    }

    debug = (msg, obj) => (window.videoDebugOn == true ? console.log(msg, obj) : '')

    getVimeoPlayer = (selector) => new Player(document.querySelector(selector).querySelector('iframe'))

    registerEventEnded = (player) => {
        //TODO - change to promise, movie removeAttr to gsAcnowledgepopup
        player.on('ended', (data) =>  jQuery("#popup-btn").removeAttr("disabled"))

        return player
    }

    disableVimeoSeek = (player) => {
        var timeWatched = 0;

        player.on("timeupdate", (data) => {
            if (data.seconds - 1 < timeWatched && data.seconds > timeWatched) {
                timeWatched = data.seconds;
            }
        });

        player.on("seeked", (data) => {
            if (timeWatched < data.seconds) {
                player.setCurrentTime(timeWatched);
            }
        });
        return player
    }
}
